import { Fragment } from 'react';

import useClubStaff from './UseClubStaff';

import ClubStaffGrid from './components/grids/clubStaff/ClubStaffGrid';
import ClubStaffLoadingModal from './components/dialogs/loadingModal/ClubStaffLoadingModal';

import Headings from '@usas/ui-web/components/headings/Headings';

const ClubStaffRead = () => {
  const {
    isLoading,
    isGridLoading,
    gridData
  } = useClubStaff();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Staff</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <ClubStaffGrid
            data={gridData}
            isLoading={isGridLoading} />
        </div>
      </div>
      <ClubStaffLoadingModal
        isLoading={isLoading} />
    </Fragment>
  );
};

export default ClubStaffRead;